import { render, staticRenderFns } from "./DockerIcon.vue?vue&type=template&id=059e82c8"
import script from "./DockerIcon.vue?vue&type=script&lang=js"
export * from "./DockerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports